import { createContext, useState } from "react";
import i18n from '../i18n';


const defaultUser = {
    id: 0,
    email: "",
    firstName: '',
    lastName: '',
    user_type: "",
    token: "",
}

export const UserDataContext = createContext({})

export default function UserDataContextManager(props) {

    const [user, setUser] = useState({
        user: JSON.parse(localStorage.getItem('user') || '{}') || defaultUser,
        setUserData: (user) => {
            setUser((current) => ({ ...current, user: user ? user : defaultUser }))
            localStorage.setItem('user', JSON.stringify(user || {}))
            i18n.changeLanguage(user?.lang || 'ro')
        },
    })

    return (
        <UserDataContext.Provider value={user} >
            {props.children}
        </UserDataContext.Provider>
    )
}

